import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { ListItem, ListItemSecondaryAction, ListItemText } from '../../material-ui/List';
import { Menu, MenuItem } from '../../material-ui/Menu';
import { MoreVertIconContrast } from '../../../icons/MoreVertIconContrast';
import DownloadAll from '../../../icons/image/DownloadAll';
import { FlightTaskRoute } from '../FlightTaskRoute/FlightTaskRoute';
import { IconButton } from '../../material-ui/IconButton';
import { getDownloadDateInfo } from './tools';
import { useStyles } from './useStyles';
import { stopPropagation } from '../../../service/eventHandlers';
import { useAnchorEl } from '../../hooks/useAnchorEl';
import { preloadSignatureUrl, removeTask, selectTask } from '../../../actions/tasks';
import { TYPES, useShowModal } from '../../../actions/modal';

export const FlightTaskItem = memo(({ id, flights, primaryText, download }) => {
    const dispatch = useDispatch();
    const showModal = useShowModal();
    const classes = useStyles();
    const [anchorEl, handleOpenMenu, handleClose] = useAnchorEl();
    const { t: translate } = useTranslation();

    const handleClickFlightTask = React.useCallback(
        (id, isNeedRedirect) => {
            dispatch(selectTask(id, { isNeedRedirect, isNeedDownload: false }))
                //TODO рисовать ошибку
                .catch((err) => console.log(err));
        },
        []
    );

    const handleClickTask = React.useCallback(
        (evt) => {
            stopPropagation(evt);
            handleClickFlightTask(id, true);
            handleClose();
        },
        [id]
    );

    const handleClickDownload = React.useCallback(
        (evt) => {
            stopPropagation(evt);
            handleClickFlightTask(id, false);
            handleClose();
        },
        [id]
    );

    const handleShowFlightTask = React.useCallback(
        (evt) => {
            stopPropagation(evt);
            dispatch(preloadSignatureUrl(id));
            showModal(TYPES.FLIGHT_TASK, { title: translate('modal.taskTitle'), id });
            handleClose();
        },
        [id]
    );

    const handleRemoveTask = React.useCallback(
        (evt) => {
            stopPropagation(evt);
            dispatch(removeTask(id));
            handleClose();
        },
        [id]
    );

    const handleMenuClick = React.useCallback((event) => {
        stopPropagation(event);
        handleOpenMenu(event);
    }, []);

    return (
        <>
            <ListItem id={id} className={classes.listItem} onClick={handleClickTask} button={true}>
                <ListItemText
                    primary={<span className={classes.primary}>{primaryText}</span>}
                    secondary={
                        <span className={classes.secondaryText}>
                            {flights.map((flight) => (
                                <FlightTaskRoute key={flight.id} {...flight} />
                            ))}
                        </span>
                    }
                />
                <ListItemSecondaryAction className={classes.actionIcon}>
                    <p className={classes.downloadStatus}>
                        {download ? getDownloadDateInfo(translate('downloaded'), download) : translate('notLoaded')}
                    </p>
                    {download ? (
                        <IconButton edge="end" onClick={handleMenuClick}>
                            <MoreVertIconContrast />
                        </IconButton>
                    ) : (
                        <IconButton edge="end" onClick={handleClickDownload}>
                            <DownloadAll />
                        </IconButton>
                    )}
                </ListItemSecondaryAction>
            </ListItem>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                <MenuItem onClick={handleClickTask}>{translate('flightTaskPage.openTask')}</MenuItem>
                <MenuItem onClick={handleShowFlightTask}>{translate('flightTaskPage.showTaskTitle')}</MenuItem>
                <MenuItem onClick={handleRemoveTask}>{translate('remove')}</MenuItem>
            </Menu>
        </>
    );
});
